import $ from 'jquery';
import Sortable from 'sortablejs';
import interactJs from 'interactjs';
import Renderer from './renderer';
import Text from './text';
import MenuObject from './menu-object';
import store from '../store';
import * as actions from '../actions';
import util, {getComponentFromPageBar, removeMenuObjectPlaceholders, selectMultiple} from '../util';
import constants from '../constants';
import history from './history';
import designService from '../service/designService';
import Matrix from "./matrix";
import cached from "./cached";
import {onComponentResize, onComponentResizeEnd, onComponentResizeStart} from "./component-resize";
import {setJumpTextSelection} from "./jump-text";
import {
    addComponent,
    onComponentDropped,
    onComponentManualMove,
    onComponentMove,
    onComponentMoveStart, VIEWPORT_CENTER
} from "./component";
import {onTemplateDropped, onTemplateMove, onTemplatePreMove, addPhotoToFrame, addVideoToFrame} from "./template";
import {markAsModified} from "./mark-as-modified";
import {setLineHeights} from "./line-height";
import {moveBackward, moveForward, moveToBack, moveToFront} from './layer';
import {setPrimaryColor} from "./colors";
import {afterZoomReposition, getCalculatedZoom} from "./zoom";
import { startRepositionFrame, deleteFramePreview } from "./reposition-frame";
import Interactable from "./interactable";
import menuObject from './menu-object';
import printService from '../service/printService';
import { updateMenuGroup } from '../service/menuGroupService';
import { placeMenuGroupOnPage, syncInGroup } from './menu-group';
import { MENU_GROUP_IN_PROGRESS } from '../component/MenuItemDataImport';
import { setMenuGroupsSourceInProgress, setApplyToMoInProgress } from '../actions';

let MULTI_MOVE_END = false;

export function getDraggedEdge(edges){
    if (edges.left && edges.top) return 'top-left';
    if (edges.left && edges.bottom) return 'bottom-left';
    if (edges.right && edges.top) return 'top-right';
    if (edges.right && edges.bottom) return 'bottom-right';

    if (edges.left) return 'left';
    if (edges.right) return 'right';
    if (edges.top) return 'top';
    if (edges.bottom) return 'bottom';
}

function initDragAndDrop() {
    if (!store.getState().isMobileVersion) {
        interactJs('.template')
          .styleCursor(false)
          .draggable({
              manualStart: true,
              onmove: onTemplateMove,
              onend: onTemplateDropped
          })
          .on('move', onTemplatePreMove);
    }

    interactJs('[data-component="frame-preview"].frame.move, .page-bar[page-component="frame-preview"]')
        .styleCursor(false)
        .draggable({
            onstart: (ev) => {
                const { $elements } = store.getState();
                onComponentMoveStart($(ev.target), ev, true);
            },
            onmove: (ev) => {
                const { $elements } = store.getState();
                onComponentMove($(ev.target), ev, true);
            },
            onend: (ev) => {
                const { $elements } = store.getState();
                onComponentDropped($(ev.target), ev, true);
            }
        })
        .resizable({
            edges: {
                left: '.btm-left, .top-left, .res-left',
                right: '.top-right, .btm-right, .res-right',
                bottom: '.btm-right, .btm-left, .res-btm',
                top: '.top-right, .top-left, .res-top'
            },
            onstart: (ev) => {
                onComponentResizeStart(ev, true);
            },
            onend: (ev) => {
                onComponentResizeEnd(ev, true);
            }
        })
        .on('resizemove', function (event) {
            const edge = getDraggedEdge(event.edges);
            onComponentResize(event, edge, true);
        });


    interactJs('.page, .frame').dropzone({overlap: 0.1});
    interactJs('.page .qr').dropzone({overlap: 'pointer'});

    document.addEventListener('dragstart', (event) => {
        if (interactJs.matchesSelector(event.target, '.img, img')) {
            event.preventDefault();
            event.stopPropagation();
        }
    });
}

function initInteractJsDragables(selector, keepAspectRatioOnResize) {
    let draggables =
        interactJs(selector)
            .styleCursor(false)
            .draggable({
                onstart: (ev) => {
                    const { $elements } = store.getState();
                    let $target = $(ev.target);
                    $target = getComponentFromPageBar($target);
                    if ($elements.length === 0) {
                        if ($target.hasClass('select')) {
                            Renderer.select($target, true);
                            store.dispatch(actions.select($target));
                            onComponentMoveStart($target, ev);
                        }
                    } else if ($elements.length === 1) {
                        onComponentMoveStart($target, ev);
                    } else {
                        let hasLocked = false;
                        let newObject = true;
                        $elements.forEach(($element) => {
                            if ($element.hasClass('locked')) hasLocked = true;
                            if ($element.is($target)) newObject = false;
                        });

                        if (!hasLocked && !newObject) {
                            $elements.forEach(($element) => onComponentMoveStart($element, ev));
                        } else if (newObject) {
                            if ($target.hasClass('select')) {
                                Renderer.select($target, true);
                                store.dispatch(actions.select($target));
                                onComponentMoveStart($target, ev);
                            }
                        }
                    }

                    Matrix.clear();
                    Matrix.init();

                    draggables.draggable({
                        // snap: {
                        //     targets:
                        //         (function() {
                        //             const coors = [];
                        //             const $window = $(window);
                        //
                        //             const pageBoundingRect = $(ev.target).parents('.page').get(0).getBoundingClientRect();
                        //             const pageHmid = pageBoundingRect.width / 2;
                        //             const pageVmid = pageBoundingRect.height / 2;
                        //
                        //             coors.push({ x: pageBoundingRect.left + $window.scrollLeft() });
                        //             coors.push({ y: pageBoundingRect.top + $window.scrollTop() });
                        //             coors.push({ x: pageBoundingRect.left + $window.scrollLeft() + pageBoundingRect.width });
                        //             coors.push({ y: pageBoundingRect.top + $window.scrollTop() + pageBoundingRect.height });
                        //
                        //             coors.push({ x: pageBoundingRect.left + $window.scrollLeft() + pageHmid, range: 30 });
                        //             coors.push({ y: pageBoundingRect.top + $window.scrollTop() + pageVmid, range: 30 });
                        //             coors.push({ x: pageBoundingRect.left + $window.scrollLeft() + pageHmid, y: pageBoundingRect.top + $window.scrollTop() + pageVmid, range: 80 });
                        //
                        //             let i;
                        //             const {length} = Matrix.getElements();
                        //             for (i = 0; i < length; i++) {
                        //                 const element = Matrix.getElements()[i];
                        //                 if (!element.id || ev.target.id === element.id ||
                        //                     util.getPageId($(ev.target)) !== element.page) {
                        //                     continue;
                        //                 }
                        //
                        //                 const el = $('#' + element.id);
                        //                 const boundingRect = el.get(0).getBoundingClientRect();
                        //                 const left = boundingRect.left + $window.scrollLeft();
                        //                 const top = boundingRect.top + $window.scrollTop();
                        //                 const hmid = left + (boundingRect.width / 2);
                        //                 const vmid = top + (boundingRect.height / 2);
                        //
                        //                 coors.push({ x: left });
                        //                 coors.push({ x: left + boundingRect.width });
                        //                 coors.push({ y: top });
                        //                 coors.push({ y: top + boundingRect.height });
                        //
                        //                 coors.push({ x: hmid });
                        //                 coors.push({ y: vmid });
                        //             }
                        //
                        //             return coors;
                        //         })(),
                        //     range: 20,
                        //     relativePoints: [
                        //         { x: 0, y: 0 },
                        //         { x: 0.5, y: 0.5 },
                        //         { x: 1, y: 1 },
                        //     ]
                        // },
                    })
                },
                onmove: (ev) => {
                    const { $elements } = store.getState();

                    if ($elements.length === 1) {
                        if ($elements[0].find('.locked').length > 0) return;
                        let $target = $(ev.target);
                        $target = getComponentFromPageBar($target);
                        onComponentMove($target, ev);
                    } else {
                        let hasLocked = false;
                        $elements.forEach(($element) => {
                            if ($element.hasClass('locked')) hasLocked = true;
                        });

                        if (!hasLocked) {
                            setJumpTextSelection(true);
                            $elements.forEach(($element) => onComponentMove($element, ev));
                        }
                    }
                },
                onend: (ev) => {
                    const { $elements } = store.getState();
                    if ($elements.length === 1) {
                        if ($elements[0].find('.locked').length > 0) return;
                        let $target = $(ev.target);
                        $target = getComponentFromPageBar($target);
                        onComponentDropped($target, ev);
                    } else {
                        let hasLocked = false;
                        $elements.forEach(($element) => {
                            if ($element.hasClass('locked')) hasLocked = true;
                        });

                        if (!hasLocked) {
                            MULTI_MOVE_END = true;
                            $elements.forEach(($element) => onComponentDropped($element, ev));
                        }
                    }
                }
            })
            .resizable({
                edges: {
                    left: '.btm-left, .top-left, .res-left',
                    right: '.top-right, .btm-right, .res-right',
                    bottom: '.btm-right, .btm-left, .res-btm',
                    top: '.top-right, .top-left, .res-top'
                },
                onstart: onComponentResizeStart,
                onend: onComponentResizeEnd,
                modifiers: keepAspectRatioOnResize ? [
                    interactJs.modifiers.aspectRatio({
                        ratio: 'preserve'
                    }),
                ] : [],
            })
            .on('resizemove', function (event) {
                const edge = getDraggedEdge(event.edges);
                onComponentResize(event, edge);
            });
}


function initKeys() {
    const $document = $(document);
    const plus_key = util.isFirefox() ? 61 : constants.PLUS_KEY;
    const minus_key = util.isFirefox() ? 173 : constants.MINUS_KEY;

    $document.keyup((ev) => {
        const { $element, isMenuContentModal, isConfigureTemplateModal, isSharingModal, isMultiSelect } = store.getState();
        if (isMenuContentModal || isConfigureTemplateModal || isSharingModal) {
            return;
        }
        const targetName = ev.target.nodeName.toLowerCase();
        if (targetName === 'input' || targetName === 'textarea') return;
        if (Renderer.getActiveEditable()) {
            if (ev.keyCode === constants.ENTER_KEY) {
                const $content = $element.closest('.content');
                $content.css('position', '');
                $content.css('position', 'relative');

                const $last = $element.find('p:last');
                $last.css('height', 'auto');
            }

            setLineHeights($element);
            Text.ensureTextSize($element);

            let $direct;
            $direct = $(ev.target).parent();
            $direct = $direct.hasClass('ql-container') ? $direct.parent() : $direct;

            if (util.isGroup($direct.parent())) {
                if (ev.keyCode !== constants.SHIFT_KEY) {
                    util.nextTick(() => {
                        Renderer.ensureGroupDimensions($direct);
                    })
                }
            }
        } else {
            const targetName = ev.target.normalizedNodeName || ev.target.nodeName.toLowerCase();
            if (!!$element && targetName !== 'input' && targetName !== 'textarea' && store.getState().selectionType !== 'menu-object' && store.getState().selectionType !== 'frame-preview') {
                if (ev.keyCode === constants.DEL_KEY || ev.keyCode === constants.BACKSPACE_KEY) {
                    let fontDropDownShown = $('.fontfamily-dropdown').filter(function() {
                        return $(this).css('display') !== 'none';
                    }).length > 0;
                    let textDropDownShown = $('.textsize-input').filter(function() {
                        return $(this).css('display') !== 'none';
                    }).length > 0;
                    let colorDropDownShown = $('.custom-color-picker-widget').filter(function() {
                        return $(this).css('display') !== 'none';
                    }).length > 0;
                    if (!fontDropDownShown && !textDropDownShown && !colorDropDownShown) {
                        if (isMultiSelect) {
                            const $els = store.getState().$elements;
                            let hasText = false;
                            $els.forEach(($el) => {
                                if (util.isText($el) || menuObject.isMenuObject($el)) {
                                    hasText = true;
                                }
                            })
                            if (!hasText) {
                                Renderer.removeElements($els);
                                Interactable.clearMultiinteractable();
                            }
                        } else {
                            ev.preventDefault();
                            Renderer.remove($element);
                        }
                    }
                }
            }
        }

        if (ev.keyCode === constants.CTRL_KEY || ev.keyCode === constants.CMD_KEY || ev.keyCode === constants.WINDOWS_CTRL_KEY) {
            store.dispatch(actions.updateCtrlPressed(false))
        }

        if (ev.keyCode === constants.SHIFT_KEY) {
            const targetName = ev.target.normalizedNodeName || ev.target.nodeName.toLowerCase();
            if (targetName !== 'input' && targetName !== 'textarea') {
                store.dispatch(actions.updateShiftPressed(false));
                $('body').removeClass('shift-pressed');
            }
        }

        Text.fixParagraphsWithLostFormatting(ev, $element);
    });

    $document.keydown((ev) => {
        const { isMenuContentModal, isConfigureTemplateModal, isSharingModal } = store.getState();
        if (isMenuContentModal || isConfigureTemplateModal || isSharingModal) {
            return
        }

        const targetName = ev.target.nodeName.toLowerCase();
        if (targetName === 'input' || targetName === 'textarea') return;

        if (store.getState().isTextHighlight && !util.isControlKey(ev.keyCode)) {
            store.dispatch(actions.disableTextHighlight());
        }
        if (ev.metaKey || ev.ctrlKey || ev.altKey) {
            if (ev.shiftKey && ev.keyCode === constants.Z_KEY) {
                history.redo();
            } else if (ev.keyCode === constants.Z_KEY) {
                history.undo();
            } else if (ev.keyCode === constants.S_KEY) {
                store.dispatch(actions.setIsSaved(false));
                store.dispatch(actions.setIsSaving(true));

                if (store.getState().hasChanges) {
                    designService.markAsModified(store.getState().designId);
                }

                designService.updateDesignHtml({
                    id: store.getState().designId,
                    html: Renderer.getPagesContent(),
                    lastSavedTag: store.getState().lastSavedTag,
                    hasChanges: store.getState().hasChanges,
                    hasVideo: store.getState().hasVideo,
                }).then(() => {
                    store.dispatch(actions.setIsSaved(true));
                    store.dispatch(actions.setIsSaving(false));
                });
                ev.preventDefault();
            } else if (ev.keyCode === constants.C_KEY) {
                if (!store.getState().isMultiSelect && util.isText(store.getState().$element)) return;
                if (store.getState().isMOEditModal) return;
                ev.preventDefault();
                if (util.isInGroup(store.getState().$element)) {
                    window.clipboardData = util.getGroup(store.getState().$element);
                } else if (store.getState().isMultiSelect) {
                    window.clipboardData = store.getState().$elements;
                } else {
                    window.clipboardData = store.getState().$element;
                }
            } else if (ev.keyCode === constants.V_KEY) {
                if (!store.getState().isMultiSelect && util.isText(store.getState().$element)) return;
                if (store.getState().isMOEditModal) return;
                ev.preventDefault();
                const $copy = Renderer.copy(window.clipboardData);
                if ($copy.length === 1) {
                    $copy.click();
                } else {
                    selectMultiple($copy);
                }
                window.clipboardData = $copy;
            } else if (ev.keyCode === constants.B_KEY) {

                Renderer.updateElementStyle(store.getState().$element, 'fontWeight', store.getState().isBold ? 'normal' : 'bold');
                actions.updateElementAttribute('isBold', !store.getState().isBold);
                store.getState().isBold = !store.getState().isBold;
            } else if (ev.keyCode === constants.I_KEY) {
                Renderer.updateElementStyle(store.getState().$element, 'fontStyle', store.getState().isItalic ? 'normal' : 'italic');
                actions.updateElementAttribute('isItalic', !store.getState().isItalic);
                store.getState().isItalic = !store.getState().isItalic;
            } else if (ev.altKey && ev.keyCode === constants.BRACKET_LEFT_KEY) {
                ev.preventDefault();
                const $element = store.getState().$element;
                if ($element && util.isPage($element)) return;
                moveToBack(store.getState().$element);
            } else if (ev.altKey && ev.keyCode === constants.BRACKET_RIGHT_KEY) {
                ev.preventDefault();
                const $element = store.getState().$element;
                if ($element && util.isPage($element)) return;
                moveToFront(store.getState().$element);
            } else if (ev.keyCode === constants.BRACKET_LEFT_KEY) {
                ev.preventDefault();
                const $element = store.getState().$element;
                if ($element && util.isPage($element)) return;
                moveBackward(store.getState().$element);
            } else if (ev.keyCode === constants.BRACKET_RIGHT_KEY) {
                ev.preventDefault();
                const $element = store.getState().$element;
                if ($element && util.isPage($element)) return;
                moveForward(store.getState().$element);
            } else if (ev.keyCode === plus_key) {
                ev.preventDefault();
                // handled in Zoom.js
            } else if (ev.keyCode === minus_key) {
                ev.preventDefault();
                // handled in Zoom.js
            }
        }



        const manualMove = (config) => {
            let prevent = false;
            const { $elements } = store.getState();

            if ($elements.length === 1) {
                prevent = onComponentManualMove(store.getState().$element, config);
            } else {
                let hasLocked = false;
                $elements.forEach(($element) => {
                    if ($element.hasClass('locked')) hasLocked = true;
                });

                if (!hasLocked) {
                    $elements.forEach(($element) => {
                        const resp = onComponentManualMove($element, config);
                        if (resp) prevent = true;
                    })
                } else {
                    return true
                }
            }

            return prevent;
        };

        if (ev.target.type !== 'text' && ev.target.type !== 'textarea' && !store.getState().isMenuContentModal && !store.getState().isMenuContentModal) {
            if (store.getState().isMultiSelect && ev.target.tagName !== 'BODY') {
                Renderer.deselectMultiSelection($(ev.target).parents('[data-component="text"]'));
            }

            if (ev.keyCode === constants.CTRL_KEY || ev.keyCode === constants.CMD_KEY || ev.keyCode === constants.WINDOWS_CTRL_KEY) {
                store.dispatch(actions.updateCtrlPressed(true));
                ev.preventDefault();
                return;
            }

            if (ev.keyCode === constants.SHIFT_KEY) {
                store.dispatch(actions.updateShiftPressed(true));
                $('body').addClass('shift-pressed');
                ev.preventDefault();
                return;
            }

            if (ev.keyCode === constants.PLUS_KEY || ev.keyCode === constants.MINUS_KEY) {
                if (ev.ctrlKey || ev.metaKey) {
                    const isFullscreen = document.querySelector('body').classList.contains('full-screen');
                    if (isFullscreen) {
                        ev.preventDefault()
                    }
                }
            }
        }

        if (ev.keyCode === constants.Z_KEY) {
            if (ev.target.tagName === 'BODY') {
                ev.preventDefault();
                return;
            }
        }

        const { $elements } = store.getState();
        const $element = store.getState().$elements[0];
        if (!$element) return;
        if (store.getState().isMOEditModal) return;

        const isQualifiedComponent = util.isImage($element)
            || (util.isText($element) && !ev.target.classList.contains('ql-editor'))
            || util.isFrame($element)
            || util.isShape($element)
            || util.isIllustration($element)
            || util.isGroup($element);

        if ((!!$element && isQualifiedComponent) || $elements.length > 1 || !util.isContentEditable($element)) {
            let preventDefault = false;

            if ($element.hasClass('locked')) {
                ev.preventDefault();
                return false;
            }

            if (ev.keyCode === constants.LEFT_KEY) {
                preventDefault = manualMove({ left: -1 * constants.MANUAL_MOVE_UNIT });
            } else if (ev.keyCode === constants.TOP_KEY) {
                preventDefault = manualMove({ top: -1 * constants.MANUAL_MOVE_UNIT });
            } else if (ev.keyCode === constants.RIGHT_KEY) {
                preventDefault = manualMove({ left: constants.MANUAL_MOVE_UNIT });
            } else if (ev.keyCode === constants.BOTTOM_KEY) {
                preventDefault = manualMove({ top: constants.MANUAL_MOVE_UNIT });
            } else if (ev.keyCode === constants.BACKSPACE_KEY) {
                preventDefault = true;
            }

            if (preventDefault) {
                ev.preventDefault();
                return false;
            }
        }

        if (util.isText($element)) {
            if (!(store.getState().isTemplate || store.getState().hasChanges)){
                markAsModified();
            }

            const $text = $element.find('.ql-editor').first();

            let selection = window.getSelection();
            let range = selection.getRangeAt(0);
            const { startContainer } = range;
            const { endContainer } = range;

            const selectionText = $.trim(selection.toString()).toLowerCase();
            const startText = $.trim(startContainer.textContent).toLowerCase();
            const endText = $.trim(endContainer.textContent).toLowerCase();

            if (selectionText === startText && selectionText !== endText) {
                $text.data('is-triple-click', true);
                const newRange = new Range();
                newRange.selectNodeContents(startContainer);

                document.getSelection().removeAllRanges();
                document.getSelection().addRange(newRange);

                selection = window.getSelection();
                selection.getRangeAt(0);
            }

            $text.find('p').each(function () {
                $(this).data('characters', $(this).text().length);
            });

            Text.ensureTextSize($element);
        }
    });

    $document.on('paste', '.txt', (ev) => {
        ev.preventDefault();
        const data = ev.originalEvent.clipboardData || window.clipboardData;
        const text = data.getData('text/plain');
        const temp = document.createElement('div');
        temp.innerHTML = text;
        document.execCommand('insertHTML', false, temp.textContent);
    })
}

const onMenuItemClick = ($this) => {
    if (!$this.hasClass('selected')) {
        store.dispatch(actions.setMoSelectedItemIdx($this.index()));
        $this.closest('.wrapper').find('.selected').removeClass('selected');
        $this.addClass('selected');
        store.dispatch(actions.setIsMOEditModal(true));
        store.dispatch(actions.setMOEditMode('items'));

        if (MenuObject.isMenuObject(store.getState().$element)) {
            syncInGroup(store.getState().$element, store.getState().menuGroups);
        }
    }
}

const onMenuItemClickSelected = () => {
    if (store.getState().isMobileVersion) {
        store.dispatch(actions.showLayoutGuideBar(false));
        store.dispatch(actions.setIsMobileAside(true));
        store.dispatch(actions.updateShiftPressed(false));
        $('body').removeClass('shift-pressed');
        store.dispatch(actions.goToView("text-mo-edit"));
        store.dispatch(actions.goToSubview("items"));
        store.dispatch(actions.setMOEditMode('items'));
    }
}

const onMenuNameClick = ($this) => {
    store.dispatch(actions.showLayoutGuideBar(false));
    $this.closest('.wrapper').find('.selected').removeClass('selected');
    $this.addClass('selected');
    window.localStorage.setItem("mo-mode", "name");
    store.dispatch(actions.setIsMOEditModal(true));
    store.dispatch(actions.setMOEditMode('name-notes'));
}

const onMenuNameClickSelected = ($this) => {
    window.localStorage.setItem("mo-mode", "name");
    if (store.getState().isMobileVersion) {
        store.dispatch(actions.showLayoutGuideBar(false));
        store.dispatch(actions.setIsMobileAside(true));
        store.dispatch(actions.goToView("text-mo-edit"));
        store.dispatch(actions.goToSubview("items"));
        store.dispatch(actions.setMOEditMode('name-notes'));
    } else {
        onMenuNameClick($this);
    }
}

const onMenuNotesClick = ($this) => {
    $this.closest('.wrapper').find('.selected').removeClass('selected');
    $this.addClass('selected');
    window.localStorage.setItem("mo-mode", "notes");
    store.dispatch(actions.setIsMOEditModal(true));
    store.dispatch(actions.setMOEditMode('name-notes'));
}

const onMenuNotesClickSelected = ($this) => {
    window.localStorage.setItem("mo-mode", "notes");
    if (store.getState().isMobileVersion) {
        store.dispatch(actions.showLayoutGuideBar(false));
        store.dispatch(actions.setIsMobileAside(true));
        store.dispatch(actions.goToView("text-mo-edit"));
        store.dispatch(actions.goToSubview("items"));
        store.dispatch(actions.setMOEditMode('name-notes'));
    } else {
        onMenuNotesClick($this);
    }
}

function initListeners() {
    const $doc = $(document);
    const $window = $(window);

    $doc.on('dblclick', '.menu-object', (ev) => {
        if (store.getState().isMobileVersion) {
            store.dispatch(actions.updateShiftPressed(false));
            $('body').removeClass('shift-pressed');

            const $element = $(ev.currentTarget);
            MenuObject.updateStateItems($element);
        }
    });

    $doc.on('click', '.template', function (ev) {
        ev.stopPropagation();
        const $page = util.getPageInViewport($('.page'));
        const $target = $(this).clone();
        store.dispatch(actions.showLayoutGuideBar(false));

        if (store.getState().isMobileVersion && $target.parents('.swap-photo-widget').length > 0) {
            $target.find('.dropdown').remove();
            $target.find('.label').remove();
            addPhotoToFrame($('div.in-focus[data-component="frame"]'), $target);
            util.hideDropdown();
        } else if (store.getState().isReplaceFrameMode) {
            $target.find('.dropdown').remove();
            $target.find('.label').remove();

            if (util.isVideoFrame($target)) {
                if ($('div.in-focus[data-component="video-frame"]').length) {
                    addVideoToFrame($('div.in-focus[data-component="video-frame"]'), $target);
                } else {
                    addVideoToFrame($('div.in-focus[data-component="frame"]'), $target);
                }
            } else {
                if ($('div.in-focus[data-component="video-frame"]').length) {
                    addPhotoToFrame($('div.in-focus[data-component="video-frame"]'), $target);
                } else {
                    addPhotoToFrame($('div.in-focus[data-component="frame"]'), $target);
                }
            }
        } else {
            store.dispatch(actions.setIsMobileAside(false));

            if ($target.hasClass('saved-qr-code')) {
                let qrsOnCanvas = $('#pages').find('.qr');
                let qrsSelected = $('#pages').find('.qr.in-focus');
                if ((qrsOnCanvas.length === 1 && util.isQRFrameEmpty(qrsOnCanvas)) || (qrsSelected.length === 1 && util.isQRFrameEmpty(qrsSelected))) {
                    let qrLink = $target.find('img').attr('src');
                    if (qrsOnCanvas.length === 1) {
                        Renderer.addQrToFrame(qrsOnCanvas, qrLink);
                        Renderer.select(qrsOnCanvas);
                        store.dispatch(actions.select(qrsOnCanvas));
                    } else {
                        Renderer.addQrToFrame(qrsSelected, qrLink);
                    }
                    util.highlightAsideQrs();
                    return;
                }
            }
            
            $target.find('.dropdown').remove();
            $target.find('.label').remove();

            addComponent($page.attr('id'), $target.html(), {
                position: {
                    left: VIEWPORT_CENTER,
                    top: VIEWPORT_CENTER
                },
                isFromTemplate: true,
                textPreset: $target.attr("data-text-preset")
            });
        }
    });

    $doc.on('mousedown', '.left, .right, .top, .btm', (ev) => {
        ev.stopPropagation();
        setJumpTextSelection(true);
    });

    $doc.on('mousedown', '.saf-stop', (ev) => {
        if (util.isSafari()) {
            ev.stopPropagation();
            return false;
        }
    });

    $doc.on('mouseup', '.left, .right, .top, .btm', () => {
        setJumpTextSelection(false);
    });

    let isSelectableInMouseFocus = false;
    let selectableInMouseFocusId = '';
    let isPageBar = false;
    let pageBar = null;
    $doc.on('mousedown', '.select, .page-bar, .moveable-area', function () {
        const $this = $(this);
        if ($this.hasClass('moveable-area')) {
            selectableInMouseFocusId = Interactable.getIdFromMovableArea($this);
        } else {
            selectableInMouseFocusId = $(this).attr('id');
        }
        isSelectableInMouseFocus = true;
        isPageBar = true;
        pageBar = $(this);
    });

    $doc.on('mouseup', '.select, .page-bar, .moveable-area', function () {
        const $this = $(this);
        let thisId = '';
        if ($this.hasClass('moveable-area')) {
            thisId = Interactable.getIdFromMovableArea($this);
        } else {
            thisId = $this.attr('id');
        }
        if (selectableInMouseFocusId === thisId) {
            setTimeout(() => {
                isSelectableInMouseFocus = false;
            });
        }
    });

    let $mousedownElement;

    $doc.on('mousedown', 'body', function (e) {
        $mousedownElement = $(e.target)
    });

    let currentlyPickingColor = false;
    $doc.on('mousedown', '.saturation-block, .saturation-block, .hue-block, .hue-sat-pointer', function(e) {
        currentlyPickingColor = true;
    })

    function afterSelectClick($this, ev=null) {
        $this = getComponentFromPageBar($this);
        if (!$this || !$this.length) return;
        const { isShiftPressed } = store.getState();
        store.dispatch(actions.showLayoutGuideBar(false));

        if (store.getState().menuObjectItems.length === 1 && JSON.stringify(store.getState().menuObjectItems[0]) === JSON.stringify(new MenuObject.MenuItem())) {
            const $menuObjectInFocus = $('.menu-object.in-focus');
            if ($menuObjectInFocus && $menuObjectInFocus.attr('id') != $this.attr('id')) {
                util.deleteEmptyMenuObject($menuObjectInFocus);
            }
        }

        if (MULTI_MOVE_END === true) {
            MULTI_MOVE_END = false;
            return;
        }

        if (!MenuObject.isMenuObject($this)) {
            store.dispatch(actions.setIsMOEditModal(false));
        }

        if (!isShiftPressed) {
            let comesFromMultiSelect = false;
            if (!Text.isSameTextClick($this)) {
                Renderer.deselectAll();
                store.dispatch(actions.disableTextHighlight());
            } else if (store.getState().isMultiSelect) {
                Renderer.deselectMultiSelection($this);
                comesFromMultiSelect = true;
            } else {
                const $target = $(ev.target);
                if ($target.closest('.ql-editor').length < 1) {
                    Text.selectEnd($this);
                }
            }

            const contentEditable = $this[0].parentElement && $this[0].parentElement.className !== 'bars';
            if (util.isText($this)) {
                Text.enableInlineStyling($this);
            }

            const skipMenuChange = $this.hasClass('menu-object') && store.getState().view.startsWith('mo-') && store.getState().$element && store.getState().$element.attr('id') === $this.attr('id');

            Renderer.select($this, false, contentEditable, comesFromMultiSelect);
            if (!skipMenuChange) {
                store.dispatch(actions.select($this));
            }
        } else {
            const { $elements } = store.getState();

            if (util.isPage($this)) {
                Renderer.deselectAll();
                const contentEditable = !!($this[0].parentElement && $this[0].parentElement.className !== 'bars');
                Renderer.select($this, false, contentEditable);
                store.dispatch(actions.select($this));
            } else {
                let isSelected = false;
                store.getState().$elements.forEach(($element) => {
                    if ($element[0] === $this[0]) isSelected = true;
                });
                if (!isSelected) {
                    if ($elements.length === 0) {
                        const contentEditable = $this[0].parentElement && $this[0].parentElement.className !== 'bars';
                        Renderer.select($this, false, contentEditable);
                        store.dispatch(actions.select($this));
                    } else {
                        Renderer.select($this);
                        store.dispatch(actions.multiSelect($this));
                    }
                } else {
                    Renderer.deselect($this);
                    store.dispatch(actions.multiDeselect($this));
                }
            }
        }
    }

    $doc.on('click', '.select, .page-bar, .moveable-area', function (ev) {
        ev.stopPropagation();
        isPageBar = false;
        let $this = $(this);
        afterSelectClick($this, ev);
    });

    $doc.on('click', '.page', function (ev) {
        const $this = $(this);

        if (MENU_GROUP_IN_PROGRESS) {
            // placeMenuGroupOnPage($this)
        }

        // if (MenuObject.isMenuObject(store.getState().$element)) {
        //     syncInGroup(store.getState().$element, store.getState().menuGroups);
        // }

        if (!MenuObject.isMenuObject($this)) {
            store.dispatch(actions.setIsMOEditModal(false));
        }

        if (isSelectableInMouseFocus) {
            ev.stopPropagation();
            isSelectableInMouseFocus = false;
            return;
        }

        if(store.getState().menuObjectItems.length === 1 && JSON.stringify(store.getState().menuObjectItems[0]) === JSON.stringify(new MenuObject.MenuItem())) {
            const $menuObjects = $(ev.target).children();
            util.deleteEmptyMenuObject($menuObjects);
        }

        if (store.getState().view === 'video-adjusts'){
            store.dispatch(actions.goToView('graphics'));
        }

        deleteFramePreview();
        Renderer.deselectAll();
        store.dispatch(actions.showLayoutGuideBar(false));
        store.dispatch(actions.deselect());
        store.dispatch(actions.select($(this)));
        ev.stopPropagation();
    });

    $doc.on('click', 'body', (ev) => {
        const $target = $(ev.target);
        removeMenuObjectPlaceholders();

        const groups = [...store.getState().menuGroups];
        groups.forEach(it => it.selected = false);
        store.dispatch(actions.setMenuGroups(groups));
        store.dispatch(setMenuGroupsSourceInProgress(false));
        store.dispatch(setApplyToMoInProgress(false));

        // if (MenuObject.isMenuObject(store.getState().$element)) {
        //     syncInGroup(store.getState().$element, store.getState().menuGroups);
        // }

        if ($target.parents('.aside-menu-object').length > 0 ||
            $target.parents('.confirmation-modal').length > 0 ||
            $target.parents('#auth-overlay').length > 0 ||
            $target.parents('#mobile-notice').length > 0 ||
            ($target.parents('#app-aside-graphics') && store.getState().isReplaceFrameMode) ||
            ($target.hasClass('upload-image') && store.getState().isReplaceFrameMode) ||
            $target.closest('#app-aside-color-picker').length > 0 ||
            $target.closest('#app-aside-wordart').length > 0 ||
            $target.closest('#app-aside-video-adjusts').length > 0 ||
            store.getState().isAltTextModal
        ) {
            return;
        }

        if (currentlyPickingColor) {
            currentlyPickingColor = false;
            return;
        }

        if ($mousedownElement &&
            ($mousedownElement.parents('.aside-menu-object').length > 0 ||
             $mousedownElement.parents('.mo-edit-modal').length > 0)) {
            return;
        }

        if (isSelectableInMouseFocus) {
            ev.stopPropagation();
            isSelectableInMouseFocus = false;
            afterSelectClick(pageBar);
            return;
        }

        store.dispatch(actions.showLayoutGuideBar(false));

        if (store.getState().menuObjectItems.length === 1 && JSON.stringify(store.getState().menuObjectItems[0]) === JSON.stringify(new MenuObject.MenuItem())) {
            const $menuObjects = $target.find('.menu-object');
            util.deleteEmptyMenuObject($menuObjects);
        }

        if (store.getState().view === 'text-mo-style' ||
            store.getState().view === 'text-mo-edit' ||
            store.getState().view === 'text-mo-layout' ||
            store.getState().view === 'text-mo-spacing' ||
            store.getState().view === 'text-mo-import'){
            if($target.get(0).id === "canvas" || $target.get(0).id === "pages") {
                store.dispatch(actions.goToView(store.getState().view));
                // store.dispatch(actions.goToSubview('designs'));
                Renderer.deselectAll();
                store.dispatch(actions.deselect());
            }
        }

        if (store.getState().view === 'video-adjusts'){
            if($target.get(0).id === "canvas" || $target.get(0).id === "pages") {
                store.dispatch(actions.goToView('graphics'));
                Renderer.deselectAll();
                store.dispatch(actions.deselect());
            }
        }

        deleteFramePreview();
        Renderer.deselectAll();
        store.dispatch(actions.deselect());
    });

    // $doc.on('click', '.main-nav ul li', (ev) => {
    //     if (store.getState().menuObjectItems.length === 1 && JSON.stringify(store.getState().menuObjectItems[0]) === JSON.stringify(new MenuObject.MenuItem())) {
    //         const $menuObjects = $doc.find('.menu-object');
    //         util.deleteEmptyMenuObject($menuObjects);
    //     }
    // });

    $doc.on('click', '#context-bar', (ev) => {
        ev.stopPropagation();
    });

    $doc.on('click', '#add-page, .add-page', () => {
        Renderer.addPage();
        store.dispatch(actions.showLayoutGuideBar(false));
        if (constants.SCALED_ZOOM_APPROACH) {
        	afterZoomReposition();
        }
    });

    $doc.on('click', '.copy-page', function () {
        let $page = $(this).parents('.page');

        if (!$page.length) {
            $page = util.getPageInViewport($('.page'))
        }

        if (!$page.length) return;

        Renderer.copyPage($page);
        store.dispatch(actions.showLayoutGuideBar(false));
        if(constants.SCALED_ZOOM_APPROACH){
        	afterZoomReposition();
        }
        util.nextTick(() => {
            Interactable.deselectAll();
        }, 75);
    });

    $doc.on('click', '.move-page-up', function () {
        const $this = $(this);
        store.dispatch(actions.showLayoutGuideBar(false));
        if ($this.hasClass('disabled')) return;

        Renderer.movePage($this.parents('.page'), 'up');
    });

    $doc.on('click', '.move-page-down', function () {
        const $this = $(this);
        store.dispatch(actions.showLayoutGuideBar(false));
        if ($this.hasClass('disabled')) return;

        Renderer.movePage($this.parents('.page'), 'down');
    });

    $doc.on('click', '.remove-page', function () {
        const $this = $(this);

        if ($this.hasClass('disabled')) return;
        store.dispatch(actions.showLayoutGuideBar(false));
        let $page = $this.parents('.page');

        if (!$page.length) {
            $page = util.getPageInViewport($('.page'));
        }

        const designId = store.getState().designId;
        const locationId = store.getState().locationId || window.data.design.locationId;

        printService.getDraftOrder(locationId).then((resp) => {
            let isInCart = false;
            let draftOrderId = '';
            let itemId = '';

            if (resp && resp.data) {
                const items = resp.data.items;

                items.forEach(item => {
                    if (item.designId == designId) {
                        isInCart = true;
                        draftOrderId = resp.data.id
                        itemId = item.id;
                    }
                })
            }

            if (isInCart) {
                window.ConfirmationModal.show({
                    title: 'Are you sure?',
                    body: 'This design is on your print cart. Removing the page will also remove the design from print cart.',
                    acceptLabel: 'Ok',
                    declineLabel: 'Cancel',
                    onAccept: () => {
                        Renderer.removePage($page);
                        if (constants.SCALED_ZOOM_APPROACH) {
                            afterZoomReposition();
                        }

                        printService.removeItem(draftOrderId, itemId);
                    },
                    onDecline: () => {
                        window.ConfirmationModal.hide();
                    }
                });
            } else {
                window.ConfirmationModal.show({
                    title: 'Are you sure?',
                    body: 'This page will be removed.',
                    acceptLabel: 'Delete',
                    declineLabel: 'Cancel',
                    onAccept: () => {
                        Renderer.removePage($page);
                        if (constants.SCALED_ZOOM_APPROACH) {
                            afterZoomReposition();
                        }
                    },
                    onDecline: () => {
                        window.ConfirmationModal.hide();
                    }
                });
            }
        });


    });

    $doc.on('dblclick', '.frame', function () {
        const $this = $(this);
        if ($this.hasClass('template') || $this.parent().hasClass('template')) return;
        startRepositionFrame($this);
    })

    setTimeout(() => {
        $('.page').each(function() {
            $(this).show();
        });
    }, 2000);

    if (store.getState().isMobileVersion) {
        document.addEventListener('touchstart', touchStartHandler);
        document.addEventListener('touchend', touchEndHandler);

        document.addEventListener('scroll', scrollHandler);

        var scrollStart = 0;
        var scrollEnd = 0;
        var zoomStart = 100;
        var zoomEnd = 100;

        var zoomInHandled = false;

        var curPage = 0;
        var nextPage = 0;
        var prevPage = 0;
        var curPageIndex = 0;
        var nextPageIndex = 0;
        var prevPageIndex = 0;

        function touchStartHandler() {
            if (zoomEnd !== 100) return;

            zoomStart = (( window.outerWidth ) / window.innerWidth) * 100;
            let zoomFactor = getCalculatedZoom() / 100;

            scrollStart = $('html, body').scrollLeft();
            let pagePoses = [];
            $('.page').each(function() {
                pagePoses.push(this.offsetLeft * zoomFactor);
            });
            curPage = getCurPage(scrollStart, pagePoses);
            curPageIndex = pagePoses.indexOf(curPage);
            nextPageIndex = curPageIndex + 1;
            prevPageIndex = curPageIndex - 1;
            nextPage = pagePoses[nextPageIndex];
            prevPage = pagePoses[prevPageIndex];
        }

        function getCurPage(pos, pagePoses) {
            return pagePoses.reduce((a, b) => {
                let aDiff = Math.abs(a - pos);
                let bDiff = Math.abs(b - pos);

                if (aDiff == bDiff) {
                    return a > b ? a : b;
                } else {
                    return bDiff < aDiff ? b : a;
                }
            });
        }

        function touchEndHandler() {
            zoomEnd = (( window.outerWidth ) / window.innerWidth) * 100;
            if (zoomStart !== zoomEnd) {
                if (zoomEnd > 100) {
                    if (!zoomInHandled) {
                        let scrollDiff = $('html, body').scrollLeft() - curPage;
                        let index = 0;
                        $('.page').each(function() {
                            if (index !== curPageIndex) {
                                $(this).hide();
                            }
                            index++;
                        })
                        $("html, body").scrollLeft(scrollDiff);
                        zoomInHandled = true;
                    }
                } else {
                    $('.page').each(function() {
                        $(this).show();
                    });
                    $("html, body").scrollLeft(curPage);
                    zoomInHandled = false;

                    $('.mobile-bottom-menu').css({ 'transform' : '' , 'bottom' : '' , 'left' : '' , 'position' : '' });
                    //$('.menu-object-edit-container').css({ 'transform' : '' , 'bottom' : '' , 'left' : '' , 'position' : '' });
                    //$('#modals').css({ 'transform' : '' , 'bottom' : '' , 'left' : '' , 'position' : '' });
                    $('.mobile-bottom-menu').removeClass('zoomed');
                    $('.menu-object-edit-container').removeClass('zoomed');
                }
                return;
            }

            scrollEnd = $('html, body').scrollLeft();
            if (scrollEnd - scrollStart > 70) {
                $("html, body").animate({ scrollLeft: nextPage });
            } else if (scrollEnd - scrollStart < -70) {
                $("html, body").animate({ scrollLeft: prevPage });
            } else if (scrollEnd !== scrollStart) {
                $("html, body").animate({ scrollLeft: curPage });
            }
        }

        var runScroll = true;
        function scrollHandler() {
            if (runScroll) {
                runScroll = false;
                setTimeout (() => {
                    if (zoomEnd > 100) {
                        let toScale = 100 / zoomEnd;

                        let tryLeft = window.pageXOffset + 'px';
                        let tryBot = document.documentElement.clientHeight - (window.pageYOffset + window.innerHeight) + 'px';

                        $('.mobile-bottom-menu').css({ 'transform' : 'scale(' + toScale + ')', 'bottom' :  tryBot, 'left' : tryLeft, 'position' : 'absolute' });
                        $('.mobile-bottom-menu').addClass('zoomed');
                    }
                    runScroll = true;

                }, 500);
            }
        }

        document.addEventListener('touchmove', function(e) { touchMoveHandler(e) }, { passive: false });
        function touchMoveHandler(e) {
            const $target = $(e.target);
            if ($target.closest('.saturation-block').length > 0 || $target.closest('.hue-block').length > 0) {
                e.preventDefault();
            }
        }
    }

    $('.page').each(function() {
        $(this).show();
    })

    document.addEventListener('fullscreenchange', function () {
        if (document.fullscreenElement) {
        } else {
            util.disableFullScreenPreview();
        }
    });

    $('#app-aside').on('mouseenter', '[data-component="illustration"]', function () {
        $(this).find('title').remove();
    });

    $window.bind('unload', () => {
       sessionStorage.removeItem('mo-edit-position');
    });

    $window.bind('beforeunload', () => {
        removeMenuObjectPlaceholders();
        if (window.forcedExit) return;

        if (store.getState().isVersionPreview) return;

        store.dispatch(actions.setIsSaved(false));
        store.dispatch(actions.setIsSaving(true));

        const hasChanges = store.getState().hasChanges;
        if (!hasChanges && !store.getState().isTemplate) {
            if (Renderer.getPagesContent().length < constants.BLANK_DESIGN_LIMIT) {
                designService.finalRemoveDesign(store.getState().designId);
                return;
            }
        }

        if (hasChanges) {
            designService.markAsModified(store.getState().designId);
        }

        designService.updateDesignHtml({
            id: store.getState().designId,
            html: Renderer.getPagesContent(),
            lastSavedTag: store.getState().lastSavedTag,
            hasChanges: true,
            hasVideo: store.getState().hasVideo
        }).then(() => {
            store.dispatch(actions.setIsSaved(true));
            store.dispatch(actions.setIsSaving(false));
        });

        updateMenuGroup({
            designId: store.getState().designId,
            memberId: store.getState().memberId,
            source: store.getState().menuGroupsSource,
            data: JSON.stringify(store.getState().menuGroups),
            html: Renderer.getPagesContent(),
        }, true).then();

        if (store.getState().showExitWarning && !window.ignoreBeforeUnloadWarning && !data.member.isDev) {
            return true;
        }
    });

    window.addEventListener("focus", () => {
        store.dispatch(actions.updateShiftPressed(false));
        $('body').removeClass('shift-pressed');
    })

    window.addEventListener("blur", () => {
        saveDesign(() => {}, true);
    })

    window.addEventListener('resize', () => {
        store.dispatch(actions.setIsMOEditModal(false));
    });

    $doc.on('mousemove', () => {
        util.resetIdle();
        util.resetSessionIdle();
    });

    $doc.on('webkitfullscreenchange mozfullscreenchange fullscreenchange', () => {
    	if (util.isEdge) {
    		if (document.webkitCurrentFullScreenElement === null) {
    			util.disableFullScreenPreview();
    		}
    	}
    });

    function initPrimaryColors() {
        $('#pages').find('[data-component="frame"][data-full-page="true"]').each(function() {
            const $this = $(this);
            if (!$this.attr('primary-color')) {
                setPrimaryColor($this);
            }
        })
    }
    setTimeout(initPrimaryColors, 3000);

    $doc.on('click', '.menu-object .items .item', function(e) {
        const $this = $(this);
        const $mo = $(this).parents('.menu-object');
        // todo: check on mobile :)
        if ($mo.hasClass('in-focus') || store.getState().isMOEditModal) {
            if ($this.hasClass('selected')) {
                onMenuItemClickSelected($this);
            } else {
                onMenuItemClick($this);
            }
        }
    });

    $doc.on('click', '.menu-object .mo-name', function(e) {
        const $this = $(this);
        const $mo = $(this).parents('.menu-object');
        if ($mo.hasClass('in-focus')) {
            if ($this.hasClass('selected')) {
                onMenuNameClickSelected($this);
            } else {
                onMenuNameClick($this);
            }
        }
    });

    $doc.on('click', '.menu-object .mo-notes', function(e) {
        const $this = $(this);
        const $mo = $(this).parents('.menu-object');
        // todo: check on mobile :)
        if ($mo.hasClass('in-focus')) {
            if ($this.hasClass('selected')) {
                onMenuNotesClickSelected($this);
            } else {
                onMenuNotesClick($this);
            }
        }
    });
}

export function saveDesign(callback = null, checkConfirmationModal = null, force = null) {
    if (store.getState().isVersionPreview) return;
    if (store.getState().isConfigureTemplateModal) return;
    if (store.getState().isSaving) return;
    if (cached.isComponentMoveInProgress) return;
    if (!force && window.isAcceptingPOS) return;
    //if (window.posConfirmationModalVisible) return;

    if (checkConfirmationModal && window.ConfirmationModal.isVisible()) return;

    store.dispatch(actions.setIsSaved(false));
    store.dispatch(actions.setIsSaving(true));
    let waitingForSave = true;

    store.dispatch(actions.setLastSaved(new Date().getTime()));
    // smartSave();
    designService.updateDesignHtml({
        id: store.getState().designId,
        lastSavedTag: store.getState().lastSavedTag,
        hasChanged: store.getState().hasChanged,
        html: Renderer.getPagesContent(),
        hasVideo: store.getState().hasVideo,
        posAutoSyncEnabled: store.getState().posAutoSyncEnabled,
        dsaAutoSyncEnabled: store.getState().dsaAutoSyncEnabled,
        linksAutoSyncEnabled: store.getState().linksAutoSyncEnabled
    }).then((resp) => {
        waitingForSave = false;
        window.FAILED_SAVES = 0;
        if (resp.data.success) {
            store.dispatch(actions.setIsSaved(true));
            store.dispatch(actions.setIsSaving(false));
            if (callback) {
                callback();
            }
        } else {
            util.showDesignInUseModal();
        }
    }).catch((err) => {
        waitingForSave = false;
        window.FAILED_SAVES += 1;
        if (window.FAILED_SAVES > 1) {
            util.showAutoSaveFailed();
        }
    });

    setTimeout(() => {
        if (waitingForSave) {
            util.showSaveHangingModal();
        }
    }, constants.saveHangWaitTime * 1000);
}

window.FAILED_SAVES = 0;
function startAutoSave() {
    setInterval(() => {
        saveDesign(() => {}, true);
    }, constants.autoSaveInterval * 1000);
}

function getDefaultTextTab() {
    const label = util.getSizeLabel(store.getState().designSize);
    const useMO = constants.DEFAULT_MO_TAB_DESIGN_LABELS.includes(label);
    return useMO ? 'mo' : 'text';
}

function init() {
    initDragAndDrop();
    initListeners();
    initKeys();
    startAutoSave();
    Renderer.loadCanvasStyles();
    Interactable.maybeFixPages();
}

export default {
    init,
    onMenuItemClick,
    onMenuItemClickSelected,
    onMenuNameClick,
    onMenuNameClickSelected,
    onMenuNotesClick,
    onMenuNotesClickSelected,
    getDefaultTextTab,
    saveDesign
}
